import { render, staticRenderFns } from "./ServiceCentreModal.vue?vue&type=template&id=ae2fceea&"
import script from "./ServiceCentreModal.vue?vue&type=script&lang=js&"
export * from "./ServiceCentreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports